import { mutate } from 'swr'
import { useState } from 'react'
import { Create_Exam_Attempt } from '@graphql/mutations'
import { Single_Book, Single_Section } from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useContext } from 'react'
import { AppContext } from '@state/context'
import {
  setCurrentActiveExamAttemptId,
  setCurrentExamAttemptInProgressId,
} from '@state/actions/appActions'
import { USER_ROLES } from '@helpers/constants'
import { keepScrollPosition } from '@helpers/exams'

const useCreateExamAttempt = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    app: { userRole, currentEditBookObject },
  } = state

  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Create_Exam_Attempt,
      // successMessage ? successMessage : 'Testförsök skapat.',
      successMessage ? successMessage : null,
      errorMessage ? errorMessage : 'Nåt gick fel!',
      async () => {
        if (userRole === USER_ROLES.STUDENT && currentEditBookObject) {
          await keepScrollPosition(mutate, [
            Single_Book,
            currentEditBookObject.id,
          ]) // refetch current book
        }

        // if (currentSection) {
        //   await mutate([Single_Section, currentSection.id]) // refetch single section
        // }
      }
    )

    if (res.success) {
      dispatch(setCurrentActiveExamAttemptId(res.createExamAttempt.id))
      dispatch(setCurrentExamAttemptInProgressId(res.createExamAttempt.id))
    }

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useCreateExamAttempt }
